import { render, staticRenderFns } from "./MenuHelp.vue?vue&type=template&id=c6539414&scoped=true&"
import script from "./MenuHelp.vue?vue&type=script&lang=js&"
export * from "./MenuHelp.vue?vue&type=script&lang=js&"
import style0 from "./MenuHelp.vue?vue&type=style&index=0&id=c6539414&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6539414",
  null
  
)

export default component.exports